/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PostUploadPrintExampleMutationRequest, PostUploadPrintExampleMutationResponse, PostUploadPrintExample400 } from "../../models/PostUploadPrintExample";
import type { RequestConfig, ResponseErrorConfig } from "@/client";
import { buildFormData } from "../../.kubb/config";

function getPostUploadPrintExampleUrl() {
  const res = { method: 'POST', url: `/api/v1/print-examples` as const }  
  return res
}

/**
 * {@link /api/v1/print-examples}
 */
export async function postUploadPrintExample({ data }: { data: PostUploadPrintExampleMutationRequest }, config: Partial<RequestConfig<PostUploadPrintExampleMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  const formData = buildFormData(requestData)  
  const res = await request<PostUploadPrintExampleMutationResponse, ResponseErrorConfig<PostUploadPrintExample400>, PostUploadPrintExampleMutationRequest>({ method : "POST", url : getPostUploadPrintExampleUrl().url.toString(), data : formData as FormData, ... requestConfig })  
  return res.data
}